import modelBaseV2 from '../../models/model-base-v2.model';

/**
 *  IMEI/SN Log Report model
 * 
 * Contains all the requests used by IMEI/SN Log Report 
 * 
 * 
 * @author cmc.pbhieu
 */

const IMEISNLogReportModel = {
    search: (body) => {
        return modelBaseV2.post('/api/imeiSnLogReport', { body })
    },

    download: (filters, fileName) => {
        const paramsMapping = {
            fromDate: "8",
            toDate: "9",
            siteIds: "31",
            promoters: "100",
            imei: "101",
            remarks: "102",
            isValid: "103",
        }

        const downloadExcelFilters = { ...filters, pageSize: 0 }

        const params = Object.entries(paramsMapping).map(([key, value]) => {
            let attr = downloadExcelFilters[key];

            return {
                code: value,
                value: attr
                    ? Array.isArray(attr)
                        ? attr.join('^')
                        : attr.toString()
                    : ""
            }
        })

        let exportConfig = {
            excelSheetNames: [
                fileName
            ],
            storedProcedureCode: "53",
            params
        }

        return modelBaseV2.postDownload(
            '/api/executesp/export/commonexcel',
            { body: exportConfig },
            fileName);
    }
}

export default IMEISNLogReportModel;